export const SWITCH = 'autoPlay/SWITCH';
export const TURN_ON = 'autoPlay/TURN_ON';
export const TURN_OFF = 'autoPlay/TURN_OFF';
